import GroupCreationLimitNoticeContainer from './GroupCreationLimitNoticeContainer';

export default GroupCreationLimitNoticeContainer;
